import React, { useEffect, useRef, useState } from "react"
import gsap from "gsap"
import Image from "../../../components/image/image"

const TeamMember = ({ blok }) => {
  const [showBio, setShowBio] = useState(false)
  const bioRef = useRef()
  const toggleRef = useRef()

  const toggleBio = () => {
    setShowBio(!showBio)
  }

  useEffect(() => {
    toggleRef.current.classList.toggle("active", showBio)
    if (showBio) {
      gsap.to(bioRef.current, {
        duration: 0.2,
        height: "auto",
        minHeight: "336px",
      })
    } else {
      gsap.to(bioRef.current, { duration: 0.2, height: 0, minHeight: 0 })
    }
  }, [showBio])

  return (
    <div className="team-member">
      <button
        className="team-member__toggle gs_reveal"
        onClick={toggleBio}
        ref={toggleRef}
        aria-label="Toggle Bio"
      />
      <div className="team-member__photo">
        <Image blok={{ image: blok.content.image }} />
        {blok.content.bio && (
          <div className="team-member__bio" ref={bioRef}>
            <div
              className="team-member__bio-content"
              dangerouslySetInnerHTML={{ __html: blok.content.bio }}
            />
          </div>
        )}
      </div>
      <div className="team-member__details gs_reveal">
        <h3 className="team-member__name">{blok.name}</h3>
        {blok.content.job_title && (
          <h5 className="team-member__title">{blok.content.job_title}</h5>
        )}
      </div>
    </div>
  )
}

export default TeamMember
